import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ValidateInputs } from "../../utils/helper";


const AddAccountModal = ({ show, handleClose, handleSave, task }) => {
  const initialData = {
    amount: task?.amount || "",
    walletAddress: task?.accountAddress || "",
  };
  const [data, setData] = useState(
    initialData
  );
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    const fields = [
      { key: "amount", value: data.amount },
      { key: "walletAddress", value: data.walletAddress },
    ];

    fields.forEach(({ key, value }) => {
      const errors = ValidateInputs(key, value, {}, data);
      if (errors[key]) {
        newErrors[key] = errors[key];
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    setData(initialData);
  }, [task]);

  const onSave = () => {
    if (!validate()) {
      return;
    }

    handleSave(data);
    setData(initialData);
    setErrors({})
  };

  const handleChange = async (e) => {
    const { name, value } = e.target
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "amount") {
      if (value === "") {
        setErrors((prev) => ({
          ...prev,
          amount: "Amount is required",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          amount: "",
        }));
      }
    }
    else {
      const updatedInputs = ValidateInputs(name, value, errors);
      setErrors(updatedInputs);
    }
  }

  console.log("show : ", show);

  return (
    <Modal show={show} onHide={() => {
      handleClose()
      setErrors({})
      setData(initialData)
    }}>
      <Modal.Header closeButton>
        <Modal.Title>{"Add Account"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Wallet Address */}
          <Form.Group className="mb-3" controlId="taskQuestion">
            <Form.Label>Wallet Address</Form.Label>
            <Form.Control
              type="text"
              name="walletAddress"
              placeholder="Enter Your Wallet Address"
              value={data.walletAddress}
              className={`${errors.walletAddress ? "is-invalid" : ""}`}
              onChange={handleChange}
              required
            />
            {errors.walletAddress && (
              <div className="invalid-feedback">{errors.walletAddress}</div>
            )}
          </Form.Group>

          <Form.Group className="mb-3" controlId="taskQuestion">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              name="amount"
              placeholder="Enter amount"
              value={data.amount}
              onChange={handleChange}
              className={`${errors.amount ? "is-invalid" : ""}`}
              required
            />
            {errors.amount && (
              <div className="invalid-feedback">{errors.amount}</div>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={() => {
          handleClose()
          setErrors({})
          setData(initialData);
        }}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddAccountModal;
